/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AccessEligibilityStatus } from "./AccessEligibilityStatus";
import type { AccessEligibilityUpdatedPayloadSideEffectType } from "./AccessEligibilityUpdatedPayloadSideEffectType";

/**
 * A CMS ACCESS eligibility check settled, so the client should refetch. Carries no result --
 * GET /access/eligibility is the authority on the outcome.
 */
export interface AccessEligibilityUpdatedPayload {
  side_effect_type: AccessEligibilityUpdatedPayloadSideEffectType;
  status: AccessEligibilityStatus;
}
